/**
 * Cookie 工具函数
 * 用于客户端读写 cookie
 */

const COOKIE_KEY = "announcement_banner_closed_id"

/**
 * 设置 cookie
 * @param name cookie 名称
 * @param value cookie 值
 * @param days 过期天数，默认 365 天
 */
function setCookie(name: string, value: string, days = 365) {
  if (typeof document === "undefined") {
    return
  }

  const date = new Date()
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
  const expires = `expires=${date.toUTCString()}`
  document.cookie = `${name}=${value};${expires};path=/;domain=.metal.com`
}

/**
 * 保存公告栏关闭时的第一条公告 ID 到 cookie
 * @param id 第一条公告的 ID
 */
export function saveAnnouncementClosedId(id: string | number) {
  setCookie(COOKIE_KEY, String(id))
}
